import { render, staticRenderFns } from "./SaleGoods.vue?vue&type=template&id=2f48259a&"
import script from "./SaleGoods.vue?vue&type=script&lang=js&"
export * from "./SaleGoods.vue?vue&type=script&lang=js&"
import style0 from "./SaleGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports